import { Award, UserCheck, Lightbulb, Leaf } from "lucide-react";
import Reveal from "@/components/Reveal";

const PILLARS = [
  { icon: Award, k: "Trusted Experts" },
  { icon: UserCheck, k: "Customer Focused" },
  { icon: Lightbulb, k: "Innovative Solutions" },
  { icon: Leaf, k: "Sustainable Growth" },
];

export default function PartnerPillars() {
  return (
    <section
      data-testid="partner-pillars"
      className="relative bg-[#04102B] text-white py-16 md:py-20 overflow-hidden border-t border-[#D4AF37]/15"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          <Reveal className="lg:col-span-4">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/80">
              The Sahyog promise
            </div>
            <h3
              data-testid="pillars-heading"
              className="font-display text-3xl md:text-4xl mt-2 leading-tight"
            >
              Let&apos;s build your <em className="not-italic text-[#F0D788]">financial future</em> together
            </h3>
            <a
              href="tel:+917016975324"
              data-testid="pillars-cta"
              className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full btn-gold text-sm font-semibold"
            >
              📞 7016975324
            </a>
          </Reveal>

          <Reveal className="lg:col-span-8" delay={100}>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {PILLARS.map(({ icon: Icon, k }, i) => (
                <div
                  key={k}
                  data-testid={`pillar-${k.toLowerCase().replace(/\s+/g, "-")}`}
                  className="rounded-2xl py-5 px-3 text-center border border-[#D4AF37]/25 bg-white/[0.04] hover:border-[#D4AF37]/65 hover:-translate-y-1 transition-all"
                >
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-md mb-3"
                        style={{ background: "linear-gradient(135deg,#0F6B3D 0%,#0B4A29 100%)" }}>
                    <Icon size={18} strokeWidth={1.75} className="text-[#F0D788]" />
                  </span>
                  <div className="font-display text-sm md:text-base uppercase tracking-wider text-white leading-tight">
                    {k}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
